import Table from "react-bootstrap/Table";

export default function ExchangeTable({ data }) {
  const formatRepName = (email) => {
    let name = email.split("@")[0];
    return name;
  };

  const buildDetails = (data) => {
    return (
      <>
        <p>From</p>
        <ul>
          {data.for_tickets.map((ticket) => (
            <li>
              Section {ticket?.section_number} Row {ticket?.row_number} Seat{" "}
              {ticket?.seat_number}
            </li>
          ))}
        </ul>

        <p className="mt-2">To</p>
        <ul>
          {data.to_tickets.map((ticket) => (
            <li>
              Section {ticket?.section_number} Row {ticket?.row_number} Seat{" "}
              {ticket?.seat_number}
            </li>
          ))}
        </ul>
      </>
    );
  };
  return (
    <Table striped bordered hover variant="dark">
      <thead>
        <tr>
          <th>Email</th>
          <th>Details</th>
          <th>Exchange Date</th>
          <th>Exchanged By</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((d, index) => (
            <tr key={index}>
              <td>{d.from_order[0]?.email}</td>
              <td>{buildDetails(d)}</td>
              <td>{d.exchanged_at}</td>
              <td>{formatRepName(d.team_rep[0]?.email)}</td>
            </tr>
          ))}
      </tbody>
    </Table>
  );
}
